// The environment last worked in, per game (spec/dashboard.md section 3.3, the environment switch): a visit to an
// environment page (`envs/{env}/…`, section 3.1) remembers its slug, and the rail's environment-scoped links and the
// environment switch default to it instead of always landing on dev. Stored in localStorage['hue.env:<gameId>']; the
// LiveOps figures selector keeps its own `hue.liveops.env`.
const key = (gameId: string) => `hue.env:${gameId}`;

export function rememberEnv(gameId: string, slug: string): void {
  try {
    localStorage.setItem(key(gameId), slug);
  } catch {
    // storage blocked: the default stays dev
  }
}

/** The remembered environment of the game, when it still exists among `environments`; otherwise null. */
export function recallEnv(gameId: string, environments: readonly { slug: string }[]): string | null {
  try {
    const slug = localStorage.getItem(key(gameId));
    return slug && environments.some((e) => e.slug === slug) ? slug : null;
  } catch {
    return null;
  }
}

/** The environment a link without one in the URL leads to: the remembered one, else dev, else the first. */
export function defaultEnv(gameId: string, environments: readonly { slug: string; kind: string }[]): string {
  return recallEnv(gameId, environments) ?? environments.find((e) => e.kind === 'dev')?.slug ?? environments[0]?.slug ?? 'dev';
}
